import advancedPromptCert from "@/assets/certificates/advanced-prompt-engineering.pdf";
import promptEngineeringCert from "@/assets/certificates/prompt-engineering-chatgpt.pdf";
import uxDesignCert from "@/assets/certificates/ux-design-awari.pdf";
import uxWritingCert from "@/assets/certificates/ux-writing-chatbots.pdf";

export interface Certification {
  id: string;
  area: "ai" | "ux" | "communication";
  institution: string;
  year: number;
  certificateUrl: string;
  verificationUrl?: string;
}

export const certifications: Certification[] = [
  {
    id: "advanced-prompt-engineering",
    area: "ai",
    institution: "Vanderbilt University",
    year: 2025,
    certificateUrl: advancedPromptCert,
    verificationUrl: "https://coursera.org/verify/R5RUIK8DSW8J",
  },
  {
    id: "prompt-engineering-chatgpt",
    area: "ai",
    institution: "Vanderbilt University",
    year: 2024,
    certificateUrl: promptEngineeringCert,
    verificationUrl: "https://coursera.org/verify/472OY21Q5U3Y",
  },
  {
    id: "ux-writing-chatbots",
    area: "ux",
    institution: "Design Conversacional",
    year: 2021,
    certificateUrl: uxWritingCert,
  },
  {
    id: "ux-design",
    area: "ux",
    institution: "Awari",
    year: 2020,
    certificateUrl: uxDesignCert,
  },
  {
    id: "journalism",
    area: "communication",
    institution: "Universidade Federal do Rio Grande do Norte",
    year: 2018,
    certificateUrl: "",
  },
];
